/**
 * @generated SignedSource<<16bbf40591e289eda01cec2d8822a849>>
 * @relayHash 757c5563496aa70c1a06c670a6332be0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/checkoutRequestPasswordEmailMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePasswordEmailInput = {
  clientMutationId?: string | null;
  email: string;
  urlRedirect?: string | null;
};
export type checkoutRequestPasswordEmailMutation$variables = {
  input: CreatePasswordEmailInput;
};
export type checkoutRequestPasswordEmailMutation$data = {
  readonly createPasswordEmail: {
    readonly message: string | null;
  } | null;
};
export type checkoutRequestPasswordEmailMutation = {
  response: checkoutRequestPasswordEmailMutation$data;
  variables: checkoutRequestPasswordEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreatePasswordEmailPayload",
    "kind": "LinkedField",
    "name": "createPasswordEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkoutRequestPasswordEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkoutRequestPasswordEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/checkoutRequestPasswordEmailMutation",
    "metadata": {},
    "name": "checkoutRequestPasswordEmailMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0150c55f62c20f525c24f52dfa6e5fd8";

export default node;
